// my-theme.ts
import { DefaultTheme } from "styled-components";

const myTheme: DefaultTheme = {
  colors: {
    INPUT_BACKGROUND: "#fbfbfb",
    BORDER_COLOR: "#EBEBEB",
    LINK_COLOR: "#16bfe6",
    LINK_COLOR_DARKENED: "#008CB3",
    ERROR_MESSAGE: "#d53131",
  },
};

export { myTheme };
